module.exports = __webpack_public_path__ + "img/Barbarian.77311a9d.png";